import { render, staticRenderFns } from "./AdressData.vue?vue&type=template&id=e68dac6c"
import script from "./AdressData.vue?vue&type=script&lang=js"
export * from "./AdressData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports